import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './components/HomePage';
import TeamPage from './pages/TeamPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BusinessLawPage from './pages/practice-areas/BusinessLawPage';
import RealEstatePage from './pages/practice-areas/RealEstatePage';
import ImmigrationPage from './pages/practice-areas/ImmigrationPage';
import WillsEstatesPage from './pages/practice-areas/WillsEstatesPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Disclaimer from './pages/Disclaimer';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/practice-areas/business-law" element={<BusinessLawPage />} />
          <Route path="/practice-areas/real-estate" element={<RealEstatePage />} />
          <Route path="/practice-areas/immigration" element={<ImmigrationPage />} />
          <Route path="/practice-areas/wills-estates" element={<WillsEstatesPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
